import { render, staticRenderFns } from "./VendorInventoryWishlistItemsCell.vue?vue&type=template&id=403e3757"
import script from "./VendorInventoryWishlistItemsCell.vue?vue&type=script&lang=js"
export * from "./VendorInventoryWishlistItemsCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports